import React, { useCallback, useId, useRef, useState } from 'react';
import { ASSETS, DS } from './ds';
import { AlinovaConstellation } from './Visuals';
interface FloatingTag {
  position: React.CSSProperties;
  label: string;
  sub: string;
  delay: string;
}
const floatingTags: FloatingTag[] = [{
  position: {
    top: '12%',
    right: '0%'
  },
  label: 'Calidad certificada',
  sub: 'Procesos bajo estándares internacionales',
  delay: '0s'
}, {
  position: {
    bottom: '22%',
    left: '0%'
  },
  label: 'Precisión ±0.1 mm',
  sub: 'Fabricación CAD/CAM digital',
  delay: '0.15s'
}, {
  position: {
    bottom: '8%',
    right: '8%'
  },
  label: 'Fuerza progresiva',
  sub: 'Plan validado por el doctor',
  delay: '0.3s'
}];
const measurementPoints: Array<[number, number]> = [[168, 260], [200, 250], [236, 248], [268, 250], [308, 260], [148, 278], [324, 278]];
export function AlignerHeroObject() {
  const [mousePos, setMousePos] = useState({
    x: 0,
    y: 0
  });
  const containerRef = useRef<HTMLDivElement>(null);
  const id = useId().replace(/:/g, '');
  const cadGradientId = `hero-cad-${id}`;
  const handleMouseMove = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width - 0.5) * 20;
    const y = ((event.clientY - rect.top) / rect.height - 0.5) * 20;
    setMousePos({
      x,
      y
    });
  }, []);
  return <div ref={containerRef} className="hero-object-shell" onMouseMove={handleMouseMove} onMouseLeave={() => setMousePos({
    x: 0,
    y: 0
  })} style={{
    position: 'relative',
    width: '100%',
    maxWidth: '520px',
    margin: '0 auto',
    aspectRatio: '1 / 1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    isolation: 'isolate'
  }} data-id="element-26" data-mp="1ut4bq1z8ymx7">
      <div aria-hidden="true" style={{
      position: 'absolute',
      inset: 0,
      borderRadius: '50%',
      background: 'radial-gradient(ellipse at 50% 50%, rgba(75,199,210,0.18) 0%, transparent 70%)',
      animation: 'haloBreath 4s ease-in-out infinite',
      pointerEvents: 'none'
    }} data-id="element-27" data-mp="1bvkzkphhso6k" />

      <div aria-hidden="true" style={{
      position: 'absolute',
      inset: '15%',
      borderRadius: '50%',
      border: '1px solid rgba(75,199,210,0.12)',
      animation: 'haloBreath 4s ease-in-out 1s infinite',
      pointerEvents: 'none'
    }} data-id="element-28" data-mp="x7balcfs9i96" />

      <AlinovaConstellation width={460} height={460} opacity={0.1} rotation="clockwise" style={{
      position: 'absolute',
      inset: 0,
      margin: 'auto',
      pointerEvents: 'none'
    }} data-id="element-29" data-mp="1b7vobu6ucnvt" />

      <svg viewBox="0 0 500 500" aria-hidden="true" style={{
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      zIndex: 3,
      opacity: 0.55,
      pointerEvents: 'none'
    }} data-id="element-30" data-mp="23u6t7h1hdayf">
        <defs data-id="element-31" data-mp="3oby12brtzav2">
          <linearGradient id={cadGradientId} x1="0" y1="0" x2="1" y2="1" data-id="element-32" data-mp="6xkj08k2m6d0">
            <stop offset="0%" stopColor={DS.color.aquaLight} stopOpacity="0.8" data-id="element-33" data-mp="6wrd19sxrkvx" />
            <stop offset="100%" stopColor={DS.color.aqua} stopOpacity="0.4" data-id="element-34" data-mp="1yzj6a8qdop3" />
          </linearGradient>
        </defs>

        <line x1="80" y1="148" x2="420" y2="148" stroke={`url(#${cadGradientId})`} strokeWidth="0.8" strokeDasharray="4 6" style={{
        animation: 'cadDraw 1.5s ease 0.5s both'
      }} data-id="element-35" data-mp="3agdhrf86wqn4" />
        <line x1="80" y1="144" x2="80" y2="152" stroke={DS.color.aquaLight} strokeWidth="0.8" data-id="element-36" data-mp="3fcb1zwmkqh56" />
        <line x1="420" y1="144" x2="420" y2="152" stroke={DS.color.aquaLight} strokeWidth="0.8" data-id="element-37" data-mp="ynp1u2s6mlc4" />
        <text x="250" y="142" textAnchor="middle" fontFamily={DS.font.body} fontSize="9" fill={DS.color.aquaLight} letterSpacing="0.7" data-id="element-38" data-mp="um3hjwdbj4rw">
          Setup Virtual
        </text>

        <line x1="448" y1="200" x2="448" y2="310" stroke={`url(#${cadGradientId})`} strokeWidth="0.8" strokeDasharray="4 6" style={{
        animation: 'cadDraw 1.5s ease 0.8s both'
      }} data-id="element-39" data-mp="1yxzrh8cu01sm" />
        <line x1="444" y1="200" x2="452" y2="200" stroke={DS.color.aquaLight} strokeWidth="0.8" data-id="element-40" data-mp="28vnwcr45ipoi" />
        <line x1="444" y1="310" x2="452" y2="310" stroke={DS.color.aquaLight} strokeWidth="0.8" data-id="element-41" data-mp="2cw7w82g407ec" />
        <text x="462" y="260" fontFamily={DS.font.body} fontSize="9" fill={DS.color.aquaLight} letterSpacing="0.7" data-id="element-42" data-mp="2hp0zsmzud9ou">
          ±0.1 mm
        </text>

        {measurementPoints.map(([x, y], index) => <g key={`${x}-${y}`} data-id="element-43" data-mp="2roi4b13cxhj8" data-mpi={index}>
            <circle cx={x} cy={y} r="3.5" fill="none" stroke={DS.color.aquaLight} strokeWidth="0.8" opacity="0.6" style={{
          animation: `blinkDot ${2 + index * 0.3}s ease-in-out ${index * 0.15}s infinite`
        }} data-id="element-44" data-mp="2wlrrea39xh3w" />
            <circle cx={x} cy={y} r="1.2" fill={DS.color.aqua} opacity="0.7" data-id="element-45" data-mp="azfk8kyptzx4" />
          </g>)}

        <path d="M148 278 Q168 252 200 248 Q236 244 268 248 Q296 252 324 278" fill="none" stroke={DS.color.aquaLight} strokeWidth="0.9" strokeDasharray="3 4" opacity="0.5" style={{
        animation: 'cadDraw 2s ease 1s both'
      }} data-id="element-46" data-mp="627a97nq126y" />

        <path d="M70 70h12v2h2v12" fill="none" stroke={DS.color.aquaLight} strokeWidth="0.9" opacity="0.45" data-id="element-47" data-mp="ty1k5wihxkzg" />
        <path d="M430 70h-12v2h-2v12" fill="none" stroke={DS.color.aquaLight} strokeWidth="0.9" opacity="0.45" data-id="element-48" data-mp="oz8h6y0u5cdj" />
        <path d="M70 430h12v-2h2v-12" fill="none" stroke={DS.color.aquaLight} strokeWidth="0.9" opacity="0.45" data-id="element-49" data-mp="1mgozevata5sm" />
        <path d="M430 430h-12v-2h-2v-12" fill="none" stroke={DS.color.aquaLight} strokeWidth="0.9" opacity="0.45" data-id="element-50" data-mp="1hmksud5gjzs2" />

        <text x="75" y="88" fontFamily={DS.font.body} fontSize="8" fill={DS.color.aquaLight} opacity="0.55" letterSpacing="0.8" data-id="element-51" data-mp="3gvmd64efq19j">
          Calidad certificada
        </text>
        <text x="75" y="100" fontFamily={DS.font.body} fontSize="7.5" fill={DS.color.aquaLight} opacity="0.35" letterSpacing="0.8" data-id="element-52" data-mp="326g6jvd9p8rm">
          Flujo digital
        </text>
        <text x="425" y="415" textAnchor="end" fontFamily={DS.font.body} fontSize="8" fill={DS.color.aquaLight} opacity="0.55" letterSpacing="0.8" data-id="element-53" data-mp="2t4yv4qat1v99">
          ALINOVA · 2026
        </text>
      </svg>

      <div className="anim-float" style={{
      position: 'relative',
      zIndex: 2,
      width: '78%',
      transform: `perspective(1000px) rotateX(${-mousePos.y * 0.5}deg) rotateY(${mousePos.x * 0.5}deg)`,
      transition: 'transform 0.15s ease',
      willChange: 'transform'
    }} data-id="element-54" data-mp="2j95il6x361rh">
        <div aria-hidden="true" style={{
        position: 'absolute',
        inset: 0,
        borderRadius: '50%',
        background: 'radial-gradient(circle at 50% 50%, #3E93AC 0%, #2C7590 60%, #1D5468 100%)',
        zIndex: 0
      }} data-id="element-55" data-mp="md7qd6he3jq9" />
        <img src={ASSETS.alignerRender} alt="Alineador invisible Alinova — transparente, preciso y discreto" style={{
        position: 'relative',
        zIndex: 1,
        width: '100%',
        borderRadius: '50%',
        mixBlendMode: 'lighten',
        filter: 'drop-shadow(0 0 40px rgba(95,227,227,0.5)) drop-shadow(0 30px 60px rgba(13,59,80,0.55))'
      }} data-id="element-56" data-mp="2bwpekqdn7uux" />
      </div>

      {floatingTags.map((tag, index) => <div key={tag.label} className={`hero-product-tag hero-product-tag-${index + 1}`} style={{
      position: 'absolute',
      ...tag.position,
      zIndex: 4,
      background: 'rgba(11,31,36,0.75)',
      backdropFilter: 'blur(12px)',
      border: '1px solid rgba(75,199,210,0.2)',
      borderRadius: '12px',
      padding: '10px 14px',
      minWidth: '150px',
      animation: `fadeUp 0.6s ${DS.ease.out} ${tag.delay} both`
    }} data-id="element-57" data-mp="157z9v44xu400" data-mpi={index}>
          <div style={{
        fontFamily: DS.font.heading,
        fontWeight: 700,
        fontSize: '12px',
        color: '#fff',
        marginBottom: '2px'
      }} data-id="element-58" data-mp="t4d4tpaw7nqo">
            {tag.label}
          </div>
          <div style={{
        fontFamily: DS.font.body,
        fontSize: '10px',
        color: DS.color.aquaLight
      }} data-id="element-59" data-mp="5e94prwwy64f">
            {tag.sub}
          </div>
        </div>)}

      <div aria-hidden="true" className="anim-pulse-glow" style={{
      position: 'absolute',
      inset: '25%',
      borderRadius: '50%',
      border: '1px solid rgba(75,199,210,0.25)',
      zIndex: 0,
      pointerEvents: 'none'
    }} data-id="element-60" data-mp="1guhcc7r7c7my" />
    </div>;
}